<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Nuevo proveedor</h1>
    </div>

    <b-card tag="article" no-body style="max-width: 960px" class="custom-card">
      <b-card-header header-tag="section" class="custom-card-header d-flex align-items-center">
        <h3>Datos del nuevo proveedor</h3>
      </b-card-header>
      <b-card-body class="custom-card-body p-0">
        <ProviderForm />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import ProviderForm from "../Components/ProviderForm.vue";

// Alta de proveedor (DEF-ADM-018). La edición vive en la tab General del detalle.
export default {
  name: "ProviderEditor",
  components: { ProviderForm },
};
</script>

<style lang="stylus" scoped></style>
